import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';

import { convertCurrency } from '~/configs';
import styles from './Membership.module.scss';
import { actionSelectAward } from '~/redux/reducer/payment';

const cx = classNames.bind(styles);

function Membership({ data = [], refs = '/app' }) {
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);
    const { awardSelected } = useSelector((state) => state.payment);

    useEffect(() => {
        if (isMobile) {
            dispatch(actionSelectAward(null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectMembership = (member) => {
        dispatch(actionSelectAward({ type: 'membership', ...member }));
    };

    const Wrapper = isMobile ? Link : 'div';

    return (
        <ul className={cx('wrapper')}>
            {data.map((member, index) => (
                <li className={cx('item')} key={index} onClick={() => handleSelectMembership(member, index)}>
                    <Wrapper to={`${refs}/${currentUser.app.code}/payment`}>
                        <div className={cx('image')}>
                            <div
                                className={
                                    awardSelected?.title === member.title && awardSelected?.type === 'membership'
                                        ? cx('border', 'active')
                                        : cx('border')
                                }
                            ></div>
                            <div>
                                <img src={member.image_url} alt={member.title} />
                            </div>

                            {member.hot && (
                                <div className={cx('discount')}>
                                    <span>Hot</span>
                                </div>
                            )}
                        </div>

                        <div
                            className={
                                awardSelected?.title === member.title && awardSelected?.type === 'membership'
                                    ? cx('name', 'active')
                                    : cx('name')
                            }
                        >
                            {member.title}
                        </div>

                        <div className={cx('price')}>{convertCurrency(member.amount.value)}</div>
                    </Wrapper>
                </li>
            ))}
        </ul>
    );
}

export default Membership;
